import { useSearch } from '@tanstack/react-router';

import { PostFilter, type PostFilterMap } from '../../../../entities/post/models';

function decodeInsightFilters(searchParams: Record<string, unknown>): PostFilterMap {
  const result: PostFilterMap = {};

  Object.values(PostFilter).forEach((filterKey) => {
    const value = searchParams[filterKey];
    if (typeof value === 'string' && value) {
      result[filterKey] = value;
    }
  });

  return result;
}

export function useInsightFiltersFromSearchParams() {
  const searchParams = useSearch({ strict: false }) as Record<string, unknown>;
  return decodeInsightFilters(searchParams);
}
